// Libs
import classNames from 'classnames/bind';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, IconButton, ListItemText, Menu, MenuItem, Tooltip, Typography } from '@mui/material';
// Components, Layouts, Pages
// Others
import { IBaseMoreAction } from '~/utils/interface/common';
import { DEFAULT_NUMBER_ZERO } from '~/utils/constants/common';
// Styles, images, icons
import styles from './BaseMoreAction.module.scss';
import { icons } from '~/assets';

type Props = {
  icon?: string;
  actions: IBaseMoreAction[];
};

const cx = classNames.bind(styles);

const BaseMoreAction = (props: Props) => {
  //#region Destructuring Props
  const { icon = icons.tableIconMenuDots, actions } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const handleShowMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  //#endregion Handle Function

  return (
    <Box component={'div'} id='baseMoreActionComponent'>
      <Tooltip arrow title={t('common_text_action')}>
        <IconButton
          size='small'
          onClick={(event) => {
            event.stopPropagation();
            handleShowMenu(event);
          }}
        >
          <img src={icon} alt={t('common_alt_img')} className={cx('moreActionIcon')} />
        </IconButton>
      </Tooltip>

      <Menu
        open={Boolean(anchorEl)}
        onClose={(event: React.MouseEvent) => {
          event.stopPropagation();
          handleCloseMenu();
        }}
        anchorEl={anchorEl}
        slotProps={{
          paper: {
            className: cx('paper'),
          },
        }}
        MenuListProps={{ className: cx('menuList') }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        autoFocus={false}
      >
        {actions.length > DEFAULT_NUMBER_ZERO ? (
          actions.map((action, index) => (
            <MenuItem
              key={index}
              className={cx('itemButton', action.hasOtherColor && 'otherColor')}
              onClick={(event) => {
                event.stopPropagation();
                action.onClick();
                handleCloseMenu();
              }}
            >
              <Box className={cx('itemIcon')}>{action.icon}</Box>

              <ListItemText
                primary={
                  <Typography className={cx('itemText', action.hasOtherColor && 'otherColor')}>
                    {action.label}
                  </Typography>
                }
              />
            </MenuItem>
          ))
        ) : (
          <Typography className={cx('noDataAvailable')}>{t('common_no_data_available')}</Typography>
        )}
      </Menu>
    </Box>
  );
};

export default BaseMoreAction;
